module.exports = "/static/assets/ddc9fae77e4b0dc8e1b094f48d1c6e18.png";